import React from "react";
import logoBlack from "../assets/logo-black.png";
// import { AiOutlineDown, AiOutlineUp } from "react-icons/ai";

const TermsAndConditions = () => {
  return (
    <div style={styles.page}>
      {/* ✅ HEADER */}
      <div style={styles.header}>
        <img
          src={logoBlack}
          alt="Conquer Life Logo"
          style={styles.logo}
        />
        <h1 style={styles.headerTitle} className="text-big-heading">CONQUER LIFE BUSINESS</h1>
      </div>

      <div style={styles.container}>
        <h1 style={styles.heading} className="text-big-heading">Terms & Conditions</h1>
        <p className="text-body">
          <strong>Effective Date:</strong> <em>February 18th, 2025</em>
        </p>

        <p className="text-body">
          Welcome to the <strong>Terms and Conditions of Use</strong> (the
          "Terms") for the <strong>Conquer Life Business Application</strong>{" "}
          (the "App"). These Terms constitute a legal agreement between you and{" "}
          <strong>Conquer Life Co.</strong> ("Company," "we," "us," or "our")
          and govern your use of the App.
        </p>

        <p className="text-body">
          By accessing or using the App, you agree to be legally bound by these
          Terms. Please read them carefully.
        </p>

        <h2 className="text-heading">1. Who We Are</h2>
        <p className="text-body">
          The <strong>Conquer Life Business App</strong> is operated by{" "}
          <strong>Conquer Life Co.</strong>, a company dedicated to providing
          services and tools for client companies and their designated users.
        </p>
        <p className="text-body">
          While the App is invite-only, users may belong to{" "}
          <strong>any organization</strong> or operate{" "}
          <strong>independently</strong>. The App is designed for client
          companies of Conquer Life Co. and their designated users, including
          employees, contractors, and partners.
        </p>
        <p className="text-body">The App allows users to:</p>
        <ul>
          <li>Access assigned session schedules</li>
          <li>Use a proprietary game library and interactive tools</li>
          <li>Communicate with mentors, admins, and other approved users</li>
        </ul>
        <p className="text-body">
          For inquiries regarding these Terms, contact us via the App’s feedback
          section or by emailing{" "}
          <a href="mailto:info@conquerlife.io">info@conquerlife.io</a>.
        </p>

        <h2 className="text-heading">2. Account Registration and Access</h2>
        <ul>
          <li>
            Accounts are created by an Admin at{" "}
            <strong>Conquer Life Co.</strong>; users cannot self-register.
          </li>
          <li>
            Accounts cannot be deleted by the user. When your relationship with
            the company or a client ends, your account will be disabled.
          </li>
          <li>
            Your profile information (name, email, phone number, profile image)
            is retained for internal records and legal compliance.
          </li>
          <li>
            You are responsible for maintaining the confidentiality of your
            login credentials.
          </li>
        </ul>

        <h2 className="text-heading">3. App Usage and Restrictions</h2>
        <p className="text-body">By using the App, you agree to:</p>
        <ul>
          <li>
            Use the App only for its intended business and training purposes
          </li>
          <li>
            Not attempt unauthorized access to any part of the App or other
            users’ information
          </li>
          <li>
            Not engage in illegal, fraudulent, or harmful activity using the App
          </li>
          <li>
            Not share your credentials or allow others to access your account
          </li>
          <li>
            Not distribute spam, offensive material, or inappropriate content
            through the App
          </li>
        </ul>

        <h2 className="text-heading">4. Communication and Chat Functionality (Coming Soon)</h2>
        <p className="text-body">The App may enable communication with:</p>
        <ul>
          <li>Assigned mentors</li>
          <li>Admins for issue resolution</li>
          <li>Other approved users</li>
        </ul>
        <p className="text-body">
          <em>
            Messages may be monitored to ensure compliance with guidelines and
            for safety.
          </em>
        </p>

        <h2 className="text-heading">5. Data Collection and Privacy</h2>
        <p className="text-body">
          Data collected through the App is subject to our{" "}
          <strong>Privacy Policy</strong>, and may include:
        </p>
        <ul>
          <li>Profile and account data</li>
          <li>Device and technical data</li>
          <li>Session and feature usage analytics</li>
        </ul>
        <p className="text-body">
          Data is only shared when required by law or necessary for internal
          operations and security. Profile images and account records are
          retained post-deactivation for compliance and auditing purposes.
        </p>

        <h2 className="text-heading">6. Security and Data Protection</h2>
        <p className="text-body">
          We implement reasonable safeguards to protect user data, including:
        </p>
        <ul>
          <li>Data encryption in transit and at rest</li>
          <li>Secure authentication mechanisms</li>
          <li>Access control limited to authorized personnel</li>
        </ul>
        <p className="text-body">
          <strong>
            <em>Important Notice:</em>
          </strong>{" "}
          While we take security seriously, no online service is 100% secure.
          You acknowledge these risks when using the App.
        </p>

        <h2 className="text-heading">7. Termination and Suspension</h2>
        <p className="text-body">We may suspend or terminate your account if:</p>
        <ul>
          <li>You violate these Terms or applicable policies</li>
          <li>You attempt to misuse the App or its data</li>
          <li>Your affiliation with Conquer Life Co. or a client ends</li>
        </ul>
        <p className="text-body">
          Upon termination, your access will be revoked and your account
          disabled.
        </p>

        <h2 className="text-heading">8. Limitation of Liability</h2>
        <ul>
          <li>
            <strong>Conquer Life Co.</strong> is not liable for direct,
            indirect, incidental, or consequential damages resulting from use of
            the App
          </li>
          <li>
            We do not guarantee uninterrupted access or error-free operation
          </li>
          <li>Your use of the App is at your own discretion and risk</li>
        </ul>

        <h2 className="text-heading">9. Intellectual Property and Usage</h2>
        <p className="text-body">
          All games, session tools, communication features, and training content
          available in the App are the intellectual property of{" "}
          <strong>Conquer Life Co.</strong>
        </p>
        <p className="text-body">
          <strong>&copy; 2025 Conquer Life Co. All rights reserved.</strong>{" "}
          Content within the App may not be reproduced, shared, or used
          externally without prior written permission from Conquer Life Co.
        </p>

        <h2 className="text-heading">10. Changes to These Terms</h2>
        <p className="text-body">
          We may update these Terms from time to time. If significant changes
          occur, you will be notified through <strong>in-app messages</strong>{" "}
          or <strong>email</strong>. The most recent version will always be
          available in the App.
        </p>

        <h2 className="text-heading">Contact Us</h2>
        <p className="text-body">
          If you have questions about these Terms, please contact us through the
          App’s feedback section or by emailing{" "}
          <a href="mailto:info@conquerlife.io">info@conquerlife.io</a>.
        </p>

        <p className="text-body">
          <strong>
            <em>Conquer Life Co.</em>
          </strong>
        </p>
      </div>
    </div>
  );
};

const styles = {
  page: {
    flex: 1,
    backgroundColor: "#FFFFFF",
  },
  header: {
    display: "flex",
    alignItems: "center",
    borderBottom: "1px solid black",
    height: "60px",
    padding: "0 15px",
    boxSizing: "border-box",
  },
  logo: {
    width: "40px",
    height: "40px",
    marginRight: "15px",
  },
  headerTitle: {
    fontSize: "26px",
    fontWeight: "bold",
    color: "black",
    margin: 0,
  },
  container: {
    padding: "2rem",
  },
  heading: {
    textAlign: "center",
    fontSize: "2.5rem",
    color: "#333",
    marginBottom: "2rem",
  },
};

export default TermsAndConditions;
